import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  summary: {
    margin: 0
  },
  actions: {
    marginBottom: 0
  },
  card: {}
}))
